/**
 * Returns true if the current leadform project is one of the given projects
 * @param projects One or more projects to check e.g. default_hagrid, utgalleries_bio_hagrid
 * @returns {boolean}
 */
export default function isProject(...projects) {
  return projects.some(project =>
    !!document.querySelector(
      `.vt-leadform-minifourstep--${project}, .vt-leadform-wizard--${project}`
    )
  );
}
